import { ref } from 'vue'

export interface WordDetails {
	wordIndex: number
	originalWord: string
	translation?: string
	transliteration?: string
	translatedWordId?: string
}

export class WordDetailsStore {
	private selectedWord = ref<WordDetails | null>(null)

	setSelectedWord(wordDetails: WordDetails) {
		this.selectedWord.value = wordDetails
	}

	clearSelectedWord() {
		this.selectedWord.value = null
	}

	getSelectedWord() {
		return this.selectedWord
	}

	get isWordSelected() {
		return this.selectedWord.value !== null
	}
}

// Create a singleton instance
export const wordDetailsStore = new WordDetailsStore()
